import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import Typography from 'antd/es/typography';
import styled from 'styled-components';

import { StatusContainer } from '../CreateDataset.styles';

const { Text } = Typography;

const StyledLoadingOutlined = styled(LoadingOutlined)`
  font-size: ${({ theme }) => theme.fontSizeHeading1 + 10}px;
  color: ${({ theme }) => theme.colorPrimary};
`;

const StyledSubtitle = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizeLG}px;
  margin-top: ${({ theme }) => theme.margin}px;
  display: block;
`;

export const ProgressContent = () => {
  return (
    <StatusContainer>
      <StyledLoadingOutlined spin />
      <StyledSubtitle>Preparing your data...</StyledSubtitle>
      <Text type="secondary">Processing file and extracting metadata</Text>
    </StatusContainer>
  );
};
